import { Achievement } from '@vae/server/dist/client'
import i18n from '../../../../i18n'

export type TranslatedAchievement = Omit<Achievement, 'nameFi' | 'nameEn' | 'descFi' | 'descEn'> & {
	title: string
	description: string
}

export const translateAchievement = (achievement: Achievement): TranslatedAchievement => {
	const { nameFi, nameEn, descFi, descEn } = achievement

	return {
		...achievement,
		title: i18n.language === 'fi' ? nameFi : nameEn,
		description: i18n.language === 'fi' ? descFi : descEn,
	}
}
